import * as React from 'react';
import { Col, Row, Divider } from 'antd';

import Form from '../../../components/Form';
import { Title } from '../../../components/Layout/components';
import GeneralSettingsCol from './components/General';
import CountriesSettingsCol from './components/Countries';
import PrivilegesSettings from './components/Privileges';

interface IUserDetailProps {
  domain: string;
  user: GQL.IUser;
  isNew: boolean;
  onSave: (user: GQL.IUser) => void;
  onCancel: () => void;
  onChangePassword?: (pw: string) => Promise<boolean | undefined>;
}

interface IUserDetailState {
  user: GQL.IUser;
  selectedCountryIds: string[];
}

export default class UserDetail extends React.Component<IUserDetailProps, IUserDetailState> {

  public constructor(props: IUserDetailProps) {
    super(props);

    this.state = {
      user: props.user || {},
      selectedCountryIds: props.user && props.user.countries
        ? props.user.countries.map(c => c.id)
        : [],
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { isNew } = this.props;
    const { user, selectedCountryIds } = this.state;

    return (
      <div>
        <Title>
          {user
            ? `Account${user.email ? ` "${user.email}"` : ''}`
            : `Accounts`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row gutter={30}>
            <Col md={12}>
              <GeneralSettingsCol
                user={user}
                isNew={isNew}
                onChange={this.onChange}
                onChangePassword={this.props.onChangePassword}
              />
              <PrivilegesSettings
                user={user}
                selectedPrivileges={user.privileges || []}
                onChange={this.onChange}
              />
            </Col>
            <Col md={12}>
              <CountriesSettingsCol
                user={user}
                selectedCountryIds={selectedCountryIds}
                onChange={this.onChange}
              />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    if (name === 'selectedCountryIds') {
      this.setState({
        selectedCountryIds: value,
      });

    } else {
      const newValue = (language
        ? { [name]: { ...this.state.user[name], [language]: inputValue } }
        : { [name]: inputValue });

      this.setState({
        user: { ...this.state.user, ...newValue }
      });
    }
  }

  private async save() {
    const user = {...this.state.user, selectedCountryIds: this.state.selectedCountryIds};
    this.props.onSave(user);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Users/UserDetail/UserDetail.tsx